<template>
  <div class="addProductDiv">
    <div class="top">
      <span>{{resourceObj.nameCn}}</span>
      <span>{{productObj.productNameCn}}</span>
    </div>
    <div class="buttton">
      <div class="leftTrip">
        <el-checkbox v-if="resourceObj.state!=4" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <div v-if="resourceObj.state==4">
          <div v-for="(item,index) in chenckBudgteObj.planDayList" :key="index">
            <span>{{dateFormatYMD(item.planDate,"-")}}&nbsp;&nbsp;</span>
            <span>D{{item.planDay}}：</span>
            <span v-for="(item1,index1) in item.cityList" :key="index1">
              {{item1.cityName}}
              <span v-if="index1!=(item.cityList.length-1)">-</span>
            </span>
          </div>
        </div>
        <el-checkbox-group v-else v-model="checkList">
          <div v-for="(item,index) in chenckBudgteObj.planDayList" :key="index">
            <el-checkbox :label="item.planDay" @change="handleCheckChange">
              <span>{{dateFormatYMD(item.planDate,"-")}}&nbsp;&nbsp;</span>
              <span>D{{item.planDay}}：</span>
              <span v-for="(item1,index1) in item.cityList" :key="index1">
                {{item1.cityName}}
                <span v-if="index1!=(item.cityList.length-1)">-</span>
              </span>
            </el-checkbox>
          </div>
        </el-checkbox-group>
      </div>
      <div class="right">
        <slot name="addProductRightDiv"></slot>
      </div>
    </div>
    <add-link-product-dialog ref="addLinkProduct"></add-link-product-dialog>
    <div class="last">
      <button @click="addBudget">保存</button>
    </div>
  </div>
</template>

<script>
import PlanApi from '@/components/Api/PlanApi.js'
import { refresh } from '../../../js/function'
import addLinkProductDialog from './addLinkProductDialog.vue'
export default {
  components: { addLinkProductDialog },
  props:{
    resourceObj:{
      type:Object,
      default:()=>{return {}} 
    },
    productObj:{
      type:Object,
      default:()=>{return {}} 
    },
    chenckBudgteObj:{
      type:Object,
      default:()=>{return {}}
    },
    keyStr:{
      type:String,
      default:''
    },
  },
  data(){
    return{
      isIndeterminate:false,
      checkAll:false,
      checkList:[],
    } 
  },
  methods:{
    handleCheckAllChange(){
      if(this.checkAll){
        this.chenckBudgteObj.planDayList.forEach(element => {
          this.checkList.push(element.planDay)
        });
      }else{
        this.checkList=[]
      }
    },
    handleCheckChange(){
      if(this.checkList.length==this.chenckBudgteObj.planDayList.length){
        this.checkAll = true
        this.isIndeterminate=false
      }else if(this.checkList.length==0){
        this.checkAll = false
        this.isIndeterminate=false
      }else{
        this.isIndeterminate=true
      }
    },
    postAddBudget(dateList){
      var arr 
      if(this.productObj.isChange){
        arr = [{
          stockId:0,
          stockNumber:this.productObj.stockNumber,
          productId:0,
          productName:this.productObj.productNameCn,
          stockPrice:this.productObj.price,
          ratio:this.productObj.salePrice,
          currency:this.productObj.currency,
          priceResult:this.productObj,
        }]
      }else{
        arr= [{
          stockId:this.productObj.stockId,
          stockNumber:this.productObj.checkNumber,
          stockPrice:this.productObj.priceList[0].price,
          ratio:this.productObj.priceList[0].salePrice
        }]
      }
      var linkIds = []
      this.$refs.addLinkProduct.dataList.forEach(ee=>{
        if(ee.isCheck){
          linkIds.push(ee.id)
        }
      })
      var obj = {
        budgetMainId:this.$store.state.budgetMainId,
        planId:this.$store.state.planId,
        state:this.resourceObj.state,
        productType:this.productObj.isChange?5:this.resourceObj.productType,
        resourceId:this.resourceObj.id,
        resourceNameCn:this.resourceObj.nameCn,
        resourceNameEn:this.resourceObj.nameEn,
        key:this.keyStr,
        planDayList:dateList,
        details:arr,
        linkBudgetIds:linkIds
      }
      new PlanApi('plan').budgetAdd(obj).then(res => {
        if (res.status == 200) {
          this.$set(this.productObj,'isChange',false)
          this.$message({type:"success",message:"添加成功"})
          this.$emit("closeDialog");
          refresh(res.data,this.$store.state.planId,this.$store.state.budgetMainId,'refresh')
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      })
    },
    addBudget(){    
      if(this.resourceObj.state==4||this.resourceObj.isLinkProduct==4){
        this.$emit('addBudget')
      }else{
        var dateList = []
        this.checkList.forEach(e=>{
          var planObj = this.chenckBudgteObj.planDayList.find(p=>p.planDay==e)
          dateList.push({
            cityId:planObj.cityId,
            cityName:planObj.cityName,
            cityNameEn:planObj.cityNameEn,
            planDate:planObj.planDate
          })
        })
        this.postAddBudget(dateList)
      }
    },
    clearData(){
      this.isIndeterminate = false;
      this.checkAll=false;
      this.checkList=[]
    }
  }
}
</script>

<style lang="scss" scoped>
.addProductDiv{
  .top{
    color: #db4e1a;
    font-weight: bold;
    >span:first-child{
      font-size: 0.16rem;
      margin-right: 0.2rem;
    }
  }
  .buttton{
    margin-top: 0.1rem;
    display: flex;
    .leftTrip{
      width: 3.8rem;
      font-weight: bold;
      margin-right: 0.1rem;
      /deep/ .el-checkbox__label{
        font-weight: bold;
      }
      >div{
        margin-top: 0.1rem;
        >div{
          margin-bottom: 0.1rem;
          height: 0.32rem;
          line-height: 0.32rem;
          >label{
            color: #000;
            
          }
        }
      }
    }
  }
  .last{
    text-align: center;
    margin-top: 0.1rem;
    button{
      color: #fff;
      background: #db4e1a;
      padding: 0.1rem 0.2rem;
      border: none;
    }
  }
}
</style>